<template>
    <label v-if="!id" aria-hidden="true" :class="{'sr-only' : !showLabel}" class="block text-sm font-medium leading-5 pb-1.5 text-bhav-blue-500">{{ label }}</label>
    <div ref="dropdown" class="bg-bhav-cool-gray-50 cursor-pointer relative rounded-md shadow-sm inline-block group sm:text-sm sm:leading-5 w-auto max-w-[22.5rem] md:max-w-96 text-bhav-blue-500" :class="open === useId ? 'z-30' : 'z-0'" @click.stop="toggleDropdown">
        <p aria-hidden="true" class="p-3 pr-8 whitespace-nowrap text-ellipsis w-full overflow-hidden z-20 relative">{{ selected }}</p>
        <ul v-if="options.length > 0 && open === useId" class="pt-8 absolute top-0 bg-bhav-cool-gray-50 focus:z-10 transition ease-in-out duration-150 rounded-md overflow-hidden shadow-xl min-w-[calc(100%+2px)]" :class="open === useId ? 'z-10' : 'z-0'" @click.stop>
            <li aria-hidden="true" class="z-20 absolute top-0 right-0 h-9 flex items-center justify-end p-2"><span class="fak fa-arrow-down"></span></li>
            <li class="flex items-center hover:bg-bhav-blue-200 px-2 py-1 whitespace-nowrap" @click.stop>
                <input type="checkbox" v-model="selectAll" :id="`${getId}-all`" :value="selectAll" class="appearance-none text-bold p-2 pr-5" :class="[!selectAll ? 'far fa-circle' : 'fas fa-circle-check text-green' ]"> 
                <label :for="`${getId}-all`">
                {{ `Select ${selectAll ? 'None' : 'All'}` }}
                </label>
            </li>
            <li v-for="option,i in options" :key="option.value" class="flex items-center hover:bg-bhav-blue-50 px-2 py-1 whitespace-nowrap" @click.stop>
                <input type="checkbox" v-model="value" :id="`${getId}-${i}`" :value="option.value" class="appearance-none text-bold p-2 pr-5" :class="[!value.includes(option.value) ? 'far fa-circle' : 'fas fa-circle-check text-green' ]"> 
                <label :for="`${getId}-${i}`">
                {{ option.label }}
                </label>
            </li>
        </ul>
        <div v-if="useId !== open" aria-hidden="true" class="z-20 absolute top-0 right-0 bottom-0 flex items-center justify-end p-2"><span class="fak fa-arrow-down"></span></div>
    </div>
</template>

<script>
import { useFormsStore } from '@/stores/forms';
import { useId } from 'vue';

export default {
    emits: [
        'update:modelValue',
        'change'
    ],
    props: {
        id: {
            type: [Boolean, String],
            default: false
        },
        modelValue: {
            required: true
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        label: {
            type: [Boolean, String],
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        all: {
            type: String,
            default: "All"
        },
        empty: {
            type: String,
            default: "None Selected"
        },
        multiple: {
            type: String,
            default: "Selected"
        }
    },
    setup() {
        return {
            useId: useId()
        }
    },
    computed: {
        open: {
            get() {
                return useFormsStore().open;
            },
            set(open) {
                useFormsStore().setOpen(open);
            }
        },
        selected() {
            if(this.value.length == 0) {
                return this.empty;
            }
            if(this.value.length === this.options.length) {
                return this.all;
            }
            return `${this.value.length} ${this.multiple}`
        },
        selectAll: {
            get() {
                return this.value.length === this.options.length
            },
            set(value) {
                if(value === true) {
                    this.value = this.options.map(option => option.value);
                } else {
                    this.value = [];
                }
            }
        },
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value)
                this.$emit('change', value)
            }
        },
        getId() {
            return this.id || `field-${this.$.uid}`;
        }
    },
    methods: {
        toggleDropdown() {
            this.open = this.open === this.useId ? null : this.useId;
        },
        closeDropdown() {
            this.open = null;
        },
        handleClickOutside(event) {
            if (this.open === this.useId && this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                this.closeDropdown();
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            document.addEventListener('click', this.handleClickOutside)
        });
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside)
    }
}
</script>